import { useMutation, useQueryClient } from '@tanstack/react-query';
import {
  createTenant,
  CreateTenantPayload,
  TenantListItem,
} from '../../api/queries';

const TENANTS_QUERY_KEY = ['GET_TENANTS'];

export const useCreateTenantMutation = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (payload: CreateTenantPayload): Promise<TenantListItem> => {
      return createTenant(payload);
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: TENANTS_QUERY_KEY });
    },
  });
};
